import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/4FaceMedia_Wortmarke_MagicWhite.svg";

const Footer = () => {
  return (
    <footer className="border-t border-border/30 bg-card/30">
      <div className="container mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/">
              <img src={logo} alt="4FaceMedia" className="h-7" />
            </Link>
            <p className="mt-6 text-foreground/85 text-base leading-relaxed font-light">
              Deine 360°-Kreativagentur für Corporate Identity, Webseiten, Medienproduktion und Social Media Marketing.
            </p>
            <div className="flex gap-3 mt-8">
              {[
                { icon: Instagram, href: "https://www.instagram.com/4face_media/", label: "Instagram" },
                { icon: Youtube, href: "https://www.youtube.com/@4FACEMEDIA", label: "YouTube" },
                { icon: Linkedin, href: "#", label: "LinkedIn" },
              ].map(({ icon: Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full border border-border/30 flex items-center justify-center text-foreground/60 hover:text-primary hover:border-primary/30 transition-all duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-base tracking-[0.2em] uppercase text-foreground/85 mb-6">Navigation</h4>
            <ul className="space-y-3">
              {["Home", "Leistungen", "Projekte", "Über uns", "Kontakt"].map((item) => (
                <li key={item}>
                  <Link
                    to={item === "Home" ? "/" : item === "Über uns" ? "/ueber-uns" : `/${item.toLowerCase()}`}
                    className="text-base text-foreground/85 hover:text-foreground transition-colors font-light"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base tracking-[0.2em] uppercase text-foreground/85 mb-6">Leistungen</h4>
            <ul className="space-y-3 text-base text-foreground/85 font-light">
              <li><Link to="/leistungen#corporate-identity" className="hover:text-foreground transition-colors">Corporate Identity</Link></li>
              <li><Link to="/leistungen#webseiten" className="hover:text-foreground transition-colors">Webseiten-Erstellung</Link></li>
              <li><Link to="/leistungen#medienproduktion" className="hover:text-foreground transition-colors">Medienproduktion</Link></li>
              <li><Link to="/leistungen#social-media" className="hover:text-foreground transition-colors">Social Media Marketing</Link></li>
              <li><Link to="/leistungen" className="hover:text-foreground transition-colors">360° Komplettpaket</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base tracking-[0.2em] uppercase text-foreground/85 mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-base text-foreground/85 font-light">
                <Mail size={16} className="text-primary/80 shrink-0" />
                <a href="mailto:info@4facemedia.de" className="hover:text-foreground transition-colors">info@4facemedia.de</a>
              </li>
              <li className="flex items-center gap-3 text-base text-foreground/85 font-light">
                <Phone size={16} className="text-primary/80 shrink-0" />
                <a href="tel:+491732354407" className="hover:text-foreground transition-colors">+49 173 235 4407</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/20 mt-16 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-foreground/85 font-light">
          <p>© {new Date().getFullYear()} 4Facemedia. Alle Rechte vorbehalten.</p>
          <div className="flex gap-8">
            <Link to="/impressum" className="hover:text-foreground/60 transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-foreground/60 transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-foreground/60 transition-colors">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
